function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "19CC61D8-479F-464F-9D60-BACA750C532F");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Location-List-Ver-1-02",
  transform: "translate(-1292.000000, -126.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Btn-Add-New",
  transform: "translate(1276.750000, 112.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.53125,19.4375 C27.6875008,19.4375 27.820312,19.492187 27.9296875,19.6015625 C28.039063,19.710938 28.09375,19.8437492 28.09375,20 C28.09375,20.1562508 28.039063,20.289062 27.9296875,20.3984375 C27.820312,20.507813 27.6875008,20.5625 27.53125,20.5625 L22.5625,20.5625 L22.5625,25.4375 C22.5625,25.5833341 22.507813,25.7135411 22.3984375,25.828125 C22.289062,25.9427089 22.1562508,26 22,26 C21.8437492,26 21.710938,25.9427089 21.6015625,25.828125 C21.492187,25.7135411 21.4375,25.5833341 21.4375,25.4375 L21.4375,20.5625 L16.5625,20.5625 C16.4166659,20.5625 16.2864589,20.507813 16.171875,20.3984375 C16.0572911,20.289062 16,20.1562508 16,20 C16,19.8437492 16.0572911,19.710938 16.171875,19.6015625 C16.2864589,19.492187 16.4166659,19.4375 16.5625,19.4375 L21.4375,19.4375 L21.4375,14.59375 C21.4375,14.4374992 21.492187,14.304688 21.6015625,14.1953125 C21.710938,14.085937 21.8437492,14.03125 22,14.03125 C22.1562508,14.03125 22.289062,14.085937 22.3984375,14.1953125 C22.507813,14.304688 22.5625,14.4374992 22.5625,14.59375 L22.5625,19.4375 L27.53125,19.4375 Z",
  id: "\\uE627"
}))));

const SvgAddButton = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-button.74ca10aa.svg";
export { ForwardRef as ReactComponent };